module.exports = __webpack_public_path__ + "img/city-tusc-logo.70c18536.jpg";